<div id="overlay" class="dummy-overlay-bg">
  <div id="dummy-overlay" (click)="onCloseClick($event)"></div>
  <div
    style="position: absolute; width: 100%"
    [ngStyle]="{ height: contentHeight + 'px' }"
  >
    <table class="wrapper">
      <tr>
        <td>
          <div id="dummy-overlay" (click)="onCloseClick($event)"></div>
          <div
            *ngIf="isDeletePopup"
            id="dummy-overlay-1"
            (click)="onDeleteNo($event)"
          ></div>
          <div class="pop-up-container">
            <img
              class="popupimg"
              src="assets/images/common/favorites_bg.webp?t={{ version }}"
            />
            <img
              class="closeiconImg"
              [appImageSprite]="'close'"
              [params]="menu_icons"
              (click)="onIconClick('close')"
            />

            <img
              class="favorites-fill lang-specific-favorites-fill"
              [appImageSprite]="'favorites_fill'"
              [params]="common_icons"
            />
            <span
              class="lang-specific-header-1-text lang-specific-font-name lang-specific-text-transform"
              [ngStyle]="{
                'text-transform': currentLanguage == 'ge' ? 'none' : 'uppercase'
              }"
            >
              {{ 'LANG00825' | translate }}</span
            >
            <span
              class="lang-specific-header-2-text lang-specific-font-name lang-specific-text-transform"
              [ngStyle]="{
                'text-transform': currentLanguage == 'ge' ? 'none' : 'uppercase'
              }"
            >
              {{ 'LANG00142' | translate }}</span
            >
            <div
              cdkDropList
              class="example-list"
              (cdkDropListDropped)="drop($event)"
            >
              <div
                *ngFor="let item of favoritesList; let i = index"
                class="example-box list-container"
                (mouseover)="onMouseOver(i)"
                (mouseout)="onMouseOut(i)"
                [ngStyle]="{ top: 0.5 + i * 10 + '%' }"
                cdkDrag
              >
                <img
                  class="rearrange"
                  [appImageSprite]="'rearrange'"
                  [currentLanguage]="currentLanguage"
                  [params]="menu_icons"
                  appToolTip="{{ 'LANG00650' | translate }}"
                  cdkDragHandle
                />
                <img
                  class="option-img"
                  [appImageSprite]="optionImage['image_' + item.select]"
                  [params]="menu_icons"
                />
                <img
                  [ngClass]="[item.tableType + '-icon']"
                  [appImageSprite]="item.tableType + '_icon'"
                  [params]="common_icons"
                />
                <!--<img [ngClass]="[item.device]" [appImageSprite]="(item.seatavailable == 3) ? item.seatavailable+'h_mobile_landscape_white@2x' : item.seatavailable+'h_mobile_portrait_white@2x'" [params]="menu_icons">-->
                <img
                  [ngClass]="[
                    (item.seatavailable == 7 ? 'desktop' : item.device) +
                      ' ' +
                      (item.seatavailable == 7
                        ? 'desktop'
                        : item.device + '-' + item.seatavailable)
                  ]"
                  [appImageSprite]="
                    deviceImage[item.seatavailable + '_' + item.device]
                  "
                  [params]="common_icons"
                />
                <!--<span [ngClass]="[item.device+'-text']">{{item.tableType == 'livecasino'? 5 : item.seatavailable}}</span>-->
                <span
                  *ngIf="item.title != 'newtable'"
                  class="text-1 lang-specific-font-name"
                  >{{ item.gameType | translate
                  }}{{ item.tableNum ? '  |  ' + item.tableNum : ''
                  }}{{ '  |  '
                  }}<span [ngClass]="userCurrency + '-text-content-string'"
                    >{{ item.min | usercurrency | currencysymbol }}{{ '-'
                    }}{{ item.max | usercurrency | currencysymbol }}</span
                  ></span
                >
                <span
                  *ngIf="item.title == 'newtable'"
                  class="text-1 lang-specific-font-name"
                  >{{ item.gameType | translate
                  }}{{ item.tableNum ? '  |  ' + item.tableNum : ''
                  }}{{ '  |  ' }}{{ 'LANG00139' | translate }}</span
                >
                <img
                  class="delete"
                  [appImageSprite]="'delete'"
                  appToolTip="{{ 'LANG00399' | translate }}"
                  [currentLanguage]="currentLanguage"
                  [params]="menu_icons"
                  (click)="onIconClick('delete', i)"
                />
                <img
                  class="arrow-icon"
                  [appImageSprite]="'arrow_icon'"
                  [params]="common_icons"
                  (click)="onIconClick('play', i)"
                />
              </div>
            </div>
            <div
              class="list-container-no-records"
              *ngIf="favoritesList.length <= 0"
            >
              <span
                *ngIf="currentLanguage == 'en'"
                class="no-records lang-specific-font-name"
                >{{ 'LANG00898' | translate }}</span
              >
              <img
                *ngIf="currentLanguage != 'en'"
                class="no-records-favorites_stroke"
                [appImageSprite]="'favorites_stroke_brown@2x'"
                [params]="common_icons"
              />
            </div>
            <div *ngIf="isDeletePopup">
              <div class="popup-dummy-bg" (click)="onDeleteNo($event)"></div>
              <img
                class="delete-popup"
                src="assets/images/common/popup-bg.webp?t={{ version }}"
              />
              <img
                class="favorites-fill-delete lang-specific-desktop-favorites-fill-delete"
                [appImageSprite]="'favorites_fill'"
                [params]="common_icons"
              />
              <span
                class="header-delete-text lang-specific-font-name lang-specific-desktop-header-delete-text"
                [ngStyle]="{
                  'text-transform':
                    currentLanguage == 'ge' ? 'none' : 'uppercase'
                }"
              >
                {{ 'LANG00825' | translate }}</span
              >
              <img
                class="delete-popup-icon"
                [appImageSprite]="'delete'"
                [params]="menu_icons"
              />
              <span
                class="delete-text lang-specific-font-name lang-specific-desktop-delete-text"
                >{{ 'LANG00399' | translate }}</span
              >
              <span
                class="no-delete-text lang-specific-font-name lang-specific-desktop-no-delete-text"
                [ngStyle]="{
                  'text-transform':
                    currentLanguage == 'ge' ? 'none' : 'uppercase'
                }"
                (click)="onDeleteNo($event)"
                >{{ 'LANG00469' | translate }}</span
              >
              <span
                class="yes-delete-text lang-specific-font-name lang-specific-desktop-yes-delete-text"
                [ngStyle]="{
                  'text-transform':
                    currentLanguage == 'ge' ? 'none' : 'uppercase'
                }"
                (click)="onDeleteYes($event)"
                >{{ 'LANG00059' | translate }}</span
              >
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
